import { ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { Brand } from "./Brand";

interface AgeGateProps {
  onConfirm: () => void;
}

export function AgeGate({ onConfirm }: AgeGateProps) {
  return (
    <main className="gate-page">
      <section className="gate-card" aria-labelledby="gate-title">
        <Brand />
        <div className="gate-card__icon" aria-hidden="true"><ShieldCheck /></div>
        <p className="eyebrow">Adults only</p>
        <h1 id="gate-title">Your private ticker starts with consent.</h1>
        <p className="gate-card__copy">
          Log only adults you saw in consensual settings. You must be at least 18 years old. Never record minors, nonconsensual activity, legal names,
          contact details, secretly captured content, or anything intended to shame or harm another person.
        </p>
        <button className="button button--primary button--full" onClick={onConfirm}>
          I am 18 or older
        </button>
        <p className="fine-print">
          By continuing, you agree to the <Link to="/terms">Terms</Link>, <Link to="/privacy">Privacy Policy</Link>,
          and <Link to="/guidelines">Community Guidelines</Link>.
        </p>
        <p className="gate-card__exit">Not 18? Please close this site.</p>
      </section>
    </main>
  );
}
